<template>
    <section
        class="relative w-full overflow-hidden rounded-3xl text-[#cf9494] max-w-screen-xl px-4 sm:px-6 lg:px-8 mx-auto pt-20 sm:pt-32 lg:pt-44 pb-12 sm:pb-16 lg:pb-20 mb-12 sm:mb-16 lg:mb-20"
        aria-label="Trust Built on Expertise - Official Nuxt Partner">

        <!-- Semicircular gradient backgrounds - responsive positioning -->
        <div
            class="w-[600px] sm:w-[800px] lg:w-[940px] h-[600px] sm:h-[750px] lg:h-[867px] rounded-full bg-[#66A3FF]/10 blur-[40px] sm:blur-[50px] lg:blur-[60px] absolute -left-3/4 sm:-left-2/3 lg:-left-1/2 top-1/2 -translate-y-1/2">
        </div>
        <div
            class="w-[600px] sm:w-[800px] lg:w-[940px] h-[600px] sm:h-[750px] lg:h-[867px] rounded-full bg-[#66A3FF]/10 blur-[40px] sm:blur-[50px] lg:blur-[60px] absolute -right-1/2 sm:-right-2/5 lg:-right-1/3 top-1/2 -translate-y-1/2">
        </div>

        <!-- Main content container - responsive layout -->
        <div class="flex flex-col lg:flex-row gap-8 lg:gap-4 items-start lg:pl-10 relative">
            <!-- Left Content -->
            <div class="flex-1 order-2 lg:order-1">
                <!-- Circuit image - responsive positioning -->
                <div class="hidden sm:block absolute left-0 -top-12 sm:-top-16 lg:-top-24">
                    <NuxtImg src="/images/circuit.png" width="298" height="180" alt="Shopping Bag"
                        class="w-48 sm:w-60 lg:w-[298px] h-auto" loading="lazy" />
                </div>

                <!-- Icon container -->
                <div
                    class="flex items-center justify-center w-16 h-16 sm:w-18 sm:h-18 lg:w-20 lg:h-20 rounded-xl lg:rounded-2xl mb-4 sm:mb-5 lg:mb-6 bg-[image:var(--primary-gradient)]">
                    <NsLogo name="NsSecureIcon"class="w-6 h-7 sm:w-7 sm:h-8 lg:w-9 lg:h-10" />
                </div>

                <!-- Main heading - responsive typography -->
                <h1
                    class="text-3xl sm:text-4xl lg:text-5xl font-bold text-[var(--text-primary)] mb-4 sm:mb-5 lg:mb-6 leading-tight">
                    Trust Built on Expertise
                </h1>

                <!-- Description text - responsive sizing and spacing -->
                <p
                    class="max-w-4xl text-base sm:text-lg lg:text-xl leading-6 sm:leading-7 lg:leading-8 text-[var(--text-gray)] mb-6 sm:mb-7 lg:mb-8">
                    With over <span class="font-semibold text-[var(--text-primary)]">15 years</span> of expertise in web
                    development and user experience design,
                    <span class="font-semibold text-[var(--text-primary)]">WebReinvent</span> stands as a trusted leader
                    in delivering innovative digital solutions.
                    <span class="font-semibold text-[var(--text-primary)]">As an official partner of Nuxt.js</span>, we
                    bring unparalleled technical excellence and insider knowledge to our projects, ensuring your
                    platform is built on a
                    foundation of cutting-edge technology and best practices.
                </p>

                <!-- CTA Button - responsive sizing -->
                <div>
                    <Button unstyled iconPos="left" class="group !rounded-lg sm:!rounded-xl !px-4 sm:!px-5 
         bg-[image:var(--primary-gradient)] hover:bg-[image:var(--primary-gradient-reverse)]
         transition-all duration-1000 ease-in-out
         !py-2.5 sm:!py-3 font-semibold
         text-[var(--text-secondary)] 
         flex items-center justify-center gap-2 sm:gap-3 
         w-full sm:w-auto text-sm sm:text-base overflow-hidden">
                        <!-- Icon -->
                        <span class="flex items-center justify-center w-5 h-5 sm:w-6 sm:h-6 
           rounded-full bg-white 
           transform transition-all duration-1000 ease-in-out 
           group-hover:translate-x-64">
                            <i class="pi pi-angle-right text-green-500 font-bold text-sm sm:text-lg"></i>
                        </span>

                        <!-- Text -->
                        <span class="transition-all duration-1000 ease-in-out group-hover:-translate-x-10">
                            Learn More About WebReinvent
                        </span>
                    </Button>

                </div>
            </div>

            <!-- Right Content - Nuxt Logo -->
            <div class="flex-shrink-0 order-1 lg:order-2 self-center lg:self-start">
                <div class="relative lg:-top-12 w-48 sm:w-60 lg:w-[281px] mx-auto lg:mx-0">
                    <div
                        class="relative aspect-square rounded-full bg-white/5 backdrop-blur-sm ring-1 ring-white/10 grid place-items-center mb-4 sm:mb-5 lg:mb-6">
                        <NsNuxtIcon class="w-16 h-16 sm:w-20 sm:h-20 lg:w-24 lg:h-24" />
                    </div>

                    <div class="text-[var(--text-secondary)] text-center">
                        <p class="text-lg sm:text-xl lg:text-2xl font-bold mb-1">Official Partner</p>
                        <p class="text-sm sm:text-base lg:text-base">Nuxt.js</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
const NsLogo = defineAsyncComponent(() => import('./NsLogo.vue'));
const NsNuxtIcon = defineAsyncComponent(() => import('~/components/atoms/icons/NsNuxtIcon.vue'));
</script>